<template>
  <div>
    <top-bar title="Pedido Realizado" link="true"/>
    <div class="container text-center">
      <div class="mx-auto" style="padding-top: 24px; max-width: 500px">
        <div class="card py-4 px-2">
          <div class="sucesso">
            <i class="fa fa-check"></i>
          </div>
          <h5 class="font-weight-bold">Pedido realizado com sucesso!</h5>
        </div>
        <hr style="margin: 42px 0 34px">
        <div>
          <i class="fa fa-heart text-primary"></i>
          <p class="small">Obrigado por pedir com a gente! <br> Acompanhe o status enquanto aguarda seu pedido.</p>
          <router-link :to="url + '/pedidos'" class="btn btn-outline-primary btn-block">
            <icon class="fi-2" name="pedido" full="true" size="20"/> Acompanhar pedido
          </router-link>
          <a :href="'https://api.whatsapp.com/send?phone=' + whatsapp" v-if="whatsapp" class="btn btn-success btn-block">
            <span class="fa fa-whatsapp"></span>
            Continuar no WhatsApp
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../../components/TopBar";
  import Icon from "../../../components/Icon";
  export default {
    name: 'Sucesso',
    components: {TopBar, Icon},
    data() {
      return {
        load: true,
        whatsapp: null,
        url: ''
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.empresa.dominio_delivery : '';
      const hash = this.$route.hash ? this.$route.hash.replace('#', '') : `55${this.empresa.whatsapp}`;
      this.whatsapp = (hash || '');
    },

    computed: {
      empresa() {
        return this.$store.state.empresa;
      }
    }
  }
</script>
<style scoped>
.sucesso {
  border: 2px solid #10b982;
  color: #10b982;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin: 0 auto 18px;
  line-height: 52px;
}

.btn {
  padding: 14px 0!important;
}

.btn span {
  font-size: 20px;
}
</style>